<div *ngIf="orgManager.viewMode === ViewMode.Album" class="container album">
    <div class="loading" *ngIf="loading">
        <myapp-loading></myapp-loading>
    </div>

    <div *ngIf="!loading">
        <myapp-org-header [album]="album"></myapp-org-header>
        <div class="breadcrumb-and-buttons">
            <myapp-breadcrumb class="breadcrumb-area" [album]="album"></myapp-breadcrumb>
            <div class="buttons">
                <p-checkbox [label]="(allPhotosSelected ? 'Unselect All (' : 'Select All (') + numPhotos + ')'" binary="true" [(ngModel)]="allPhotosSelected" (onChange)="onSelectAllChanged()"></p-checkbox>
                <button class="download-button" type="button" (click)="onDownloadClicked()"
                        [disabled]="numPhotosSelected === 0"><i class="fa fa-fw fa-download"></i></button>
            </div>
        </div>
        <div class="no-images" *ngIf="visibleImageAssets.length === 0">There are no pictures in this album.</div>

        <div class="image-scroll-region">
            <div *ngFor="let imageAsset of visibleImageAssets; let i = index" class="image-container" (click)="onPhotoClicked(i)">
                <myapp-image-asset [imageAsset]="imageAsset" [width]="200" [height]="200" [usePlaceholder]="true" [scaleToFitContainer]="true"
                                   [allowImageSelection]="true" (imageSelected)="onImageAssetSelected(imageAsset)">
                </myapp-image-asset>
            </div>
        </div>
    </div>
</div>

<p-dialog *ngIf="totalDownloadCount > 0" [visible]="totalDownloadCount > 0" [modal]="true" [closable]="false" [showHeader]="true" [responsive]="true">
    <p-header>Downloading photos</p-header>
    <div class="download-status-dialog">
        <div *ngIf="!downloadComplete" class="current-download">
            <div class="download-image-container">
                <myapp-image-asset [imageAsset]="currentDownloadImage" [width]="100" [height]="100" [usePlaceholder]="true" [scaleToFitContainer]="true">
                </myapp-image-asset>
            </div>

            <div class="download-status">Downloading {{currentDownloadCount}} of {{totalDownloadCount}}...</div>
        </div>

        <div *ngIf="failedDownloadCount > 0" class="text-danger">{{failedDownloadCount}} image{{failedDownloadCount === 1 ? '' : 's'}} failed to download.</div>

        <div *ngIf="downloadComplete" class="results">
            Successfully downloaded {{successfulDownloadCount}} of {{totalDownloadCount}}.
        </div>

        <div class="dialog-buttons">
            <button *ngIf="!downloadComplete" pButton type="button" label="Stop Download" icon="fa fa-stop-circle" (click)="onStopDownload()" [disabled]="stoppingDownload"></button>
            <button *ngIf="downloadComplete" pButton type="button" label="Finished" (click)="onFinishedDownload()"></button>
        </div>
    </div>
</p-dialog>
